import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import { browserHistory } from 'react-router';
import RaisedButton from 'material-ui/RaisedButton';
import Chip from 'material-ui/Chip';
import moment from 'moment';
import { getOrgUsers, setUserStatusSelection } from 'redux/modules/organization';
import { ButtonBar, DataTable, EmptyState, NewUserDialog, PageHeader, SecondaryButton } from 'components';
var OrgSettings = (_dec = connect(function (state) {
  return {
    organization: state.organization.current,
    theme: state.theme,
    loadingUsers: state.organization.loadingUsers,
    users: state.organization.users,
    clientDetail: state.teamManagement.clientDetail
  };
}, {
  getOrgUsers: getOrgUsers,
  setUserStatusSelection: setUserStatusSelection
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(OrgSettings, _Component);

  var _super = _createSuper(OrgSettings);

  function OrgSettings(props) {
    var _this;

    _classCallCheck(this, OrgSettings);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.props.getOrgUsers(_this.props.params.organizationId);
    });

    _defineProperty(_assertThisInitialized(_this), "handleButtonBarChange", function (tab) {
      var tabCopy = [].concat(_this.state.tabs);
      tabCopy.forEach(function (t) {
        t.selected = t.key === tab.key;
      });

      _this.setState({
        selectedTab: tab.key,
        tabs: tabCopy
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleRowSelection", function (selectedRows) {
      browserHistory.push({
        pathname: "/org/".concat(_this.props.organization.id, "/settings/users/").concat(selectedRows.id)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleStatusSelection", function (tab) {
      _this.props.setUserStatusSelection(tab.key);
    });

    _this.state = {
      newUserDialogOpen: false,
      prePopulate: false,
      newUserEmail: null,
      newUserFirstName: null,
      newUserLastName: null,
      tabs: [{
        title: 'Active',
        selected: true,
        key: 'ACTIVE'
      }, {
        title: 'Inactive',
        key: 'INACTIVE'
      }],
      selectedTab: 'ACTIVE'
    };
    return _this;
  }

  _createClass(OrgSettings, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.setUserStatusSelection('ACTIVE');
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var inactiveUsers = this.props.users && !!this.props.users.length ? this.props.users.filter(function (u) {
        return u.status === 'INACTIVE';
      }) : [];
      var activeUsers = this.props.users && !!this.props.users.length ? this.props.users.filter(function (u) {
        return u.status !== 'INACTIVE';
      }) : [];
      var users = this.state.selectedTab === 'ACTIVE' ? activeUsers : inactiveUsers;
      var formattedUsers = users.map(function (m) {
        return {
          name: /*#__PURE__*/React.createElement("div", null, "".concat(m.firstName, " ").concat(m.lastName), m.status === 'PENDING' && /*#__PURE__*/React.createElement(Chip, {
            style: {
              display: 'inline-block',
              marginLeft: '5px',
              padding: '0px'
            }
          }, "Pending"), m.status === 'INACTIVE' && /*#__PURE__*/React.createElement(Chip, {
            style: {
              display: 'inline-block',
              marginLeft: '5px',
              padding: '0px'
            }
          }, "Inactive")),
          joinedAt: moment(m.joinedAt).format('L'),
          email: m.email,
          id: m.id
        };
      });
      var headerFields = [{
        name: 'Name',
        key: 'name'
      }, {
        name: 'Email',
        key: 'email'
      }, {
        name: 'Date Joined',
        key: 'joinedAt'
      }];
      return /*#__PURE__*/React.createElement("div", {
        style: {
          padding: 36,
          paddingTop: 0
        },
        id: "OrgUsers"
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "Organization Users"
      }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'space-between'
        }
      }, /*#__PURE__*/React.createElement(PageHeader, {
        primary: "Users"
      }), /*#__PURE__*/React.createElement("span", {
        onClick: function onClick() {
          _this2.setState({
            newUserDialogOpen: true
          });
        }
      }, !!activeUsers.length && /*#__PURE__*/React.createElement(SecondaryButton, {
        label: "Add User",
        style: {
          marginRight: 32,
          marginTop: 22
        }
      })))))), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex'
        }
      }, /*#__PURE__*/React.createElement(ButtonBar, {
        items: this.state.tabs,
        onChange: this.handleButtonBarChange
      })), this.state.selectedTab === 'ACTIVE' ? /*#__PURE__*/React.createElement("div", null, formattedUsers.length ? /*#__PURE__*/React.createElement(DataTable, {
        hideSort: true,
        firstColColored: true,
        headerFields: headerFields,
        data: formattedUsers,
        fixedHeader: true,
        height: 500,
        isLoading: this.props.loadingUsers,
        displayLoading: true,
        onRowSelection: function onRowSelection(selectedRows) {
          return _this2.handleRowSelection(selectedRows);
        }
      }) : !this.props.loadingUsers ? /*#__PURE__*/React.createElement(EmptyState, {
        buttonLabel: "Add users",
        buttonOnClick: function buttonOnClick() {
          _this2.setState({
            newUserDialogOpen: true
          });
        },
        text: "".concat(this.props.organization.name, " has no active users."),
        iconName: "fa fa-user",
        iconSize: "95px",
        style: {
          marginTop: 24
        }
      }) : null, this.props.users && !this.props.users.length && !!this.props.clientDetail.length && /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          marginTop: 40,
          paddingTop: 24,
          borderTop: '1px solid #dfdfdf'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: 8,
          flex: '1 1 100%',
          textAlign: 'center'
        }
      }, this.props.organization.name, " is owned by", ' ', this.props.clientDetail[0].contract_lastName ? "".concat(this.props.clientDetail[0].contract_firstName, " ").concat(this.props.clientDetail[0].contract_lastName) : this.props.clientDetail[0].contract_email), /*#__PURE__*/React.createElement(RaisedButton, {
        secondary: true,
        label: "Add As A User Now",
        onClick: function onClick() {
          _this2.setState({
            prePopulate: true,
            newUserFirstName: _this2.props.clientDetail[0].contract_firstName,
            newUserLastName: _this2.props.clientDetail[0].contract_lastName,
            newUserEmail: _this2.props.clientDetail[0].contract_email
          }, function () {
            _this2.setState({
              newUserDialogOpen: true
            });
          });
        }
      }))) : /*#__PURE__*/React.createElement("div", null, formattedUsers.length ? /*#__PURE__*/React.createElement(DataTable, {
        hideSort: true,
        firstColColored: true,
        headerFields: headerFields,
        data: formattedUsers,
        fixedHeader: true,
        height: 500,
        isLoading: this.props.loadingUsers,
        displayLoading: true,
        onRowSelection: function onRowSelection(selectedRows) {
          return _this2.handleRowSelection(selectedRows);
        }
      }) : !this.props.loadingUsers ? /*#__PURE__*/React.createElement(EmptyState, {
        text: "".concat(this.props.organization.name, " has no inactive users."),
        iconName: "fa fa-user-times",
        iconSize: "95px",
        style: {
          marginTop: 24
        }
      }) : null), /*#__PURE__*/React.createElement(NewUserDialog, {
        userType: "User",
        open: this.state.newUserDialogOpen,
        email: this.state.newUserEmail,
        firstName: this.state.newUserFirstName,
        lastName: this.state.newUserLastName,
        prePopulate: this.state.prePopulate,
        onRequestClose: function onRequestClose() {
          _this2.setState({
            newUserDialogOpen: false,
            prePopulate: false,
            newUserEmail: null,
            newUserFirstName: null,
            newUserLastName: null
          });
        },
        onInviteSubmitted: function onInviteSubmitted() {
          _this2.props.getOrgUsers(_this2.props.organization.id);
        }
      }));
    }
  }]);

  return OrgSettings;
}(Component), _defineProperty(_class2, "propTypes", {
  children: PropTypes.any
}), _temp)) || _class);
export default OrgSettings;